import { type QueryFunctionContext } from '@tanstack/react-query'
import { apiGet } from '@/features/shared/utils/dataFetching'
import { type RatingsAndReviewsResponse } from '@/features/account/services/RatingsAndReviews/types'
import { type RatingsAndReviewsQueryKey } from '@/features/account/services/RatingsAndReviews/queries'

export const fetchRatingsAndReviews = (
  context: QueryFunctionContext<RatingsAndReviewsQueryKey, string>,
) => {
  const { queryKey, pageParam } = context
  const [, { productId, sortByParam }] = queryKey
  return apiGet<RatingsAndReviewsResponse>({
    config: {
      url: `v1/products/${productId}/reviews`,
      params: {
        cursor: pageParam,
        page_size: 10,
        sort_by: sortByParam,
      },
    },
    context,
    fetcherName: 'fetchRatingsAndReviews',
  })
}
